/* HapNuts Theme — storefront interactions (original) */
(function () {
  "use strict";

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || "₹{{amount}}";
    var value = (cents / 100).toFixed(0);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format.replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas);
  }

  /* ---------- toast ---------- */
  var toastEl;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>' + message;
    toastEl.classList.add("is-visible");
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("is-visible"); }, 2400);
  }

  /* ---------- header scroll + mobile nav ---------- */
  var header = document.querySelector(".site-header");
  function onScroll() { if (header) header.classList.toggle("is-scrolled", window.scrollY > 24); }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  document.addEventListener("click", function (e) {
    var menuBtn = e.target.closest("[data-menu-toggle]");
    if (menuBtn) {
      var nav = document.querySelector(".mobile-nav");
      if (nav) nav.classList.toggle("is-open");
      return;
    }
    var drawerToggle = e.target.closest("[data-cart-open]");
    if (drawerToggle) { e.preventDefault(); openCart(); return; }
    var drawerClose = e.target.closest("[data-cart-close]");
    if (drawerClose) { closeCart(); return; }
  });

  /* ---------- reveal on scroll ---------- */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add("is-visible"); revealObs.unobserve(en.target); }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
  function watchReveals(scope) {
    (scope || document).querySelectorAll(".reveal:not(.is-visible)").forEach(function (el) { revealObs.observe(el); });
  }
  watchReveals();

  /* ---------- cart drawer ---------- */
  var drawerRoot = document.querySelector(".drawer-root");
  function openCart() {
    if (!drawerRoot) return;
    refreshCart();
    drawerRoot.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!drawerRoot) return;
    drawerRoot.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  window.hnOpenCart = openCart;

  function cartItemHTML(item) {
    var img = item.image
      ? '<div class="cart-line__img"><img src="' + item.image + '" alt=""></div>'
      : "";
    return (
      '<li class="cart-line" data-key="' + item.key + '">' + img +
      '<div class="cart-line__main">' +
        '<div class="cart-line__top"><div>' +
          '<p class="cart-line__title">' + item.product_title + "</p>" +
          (item.variant_title ? '<p class="cart-line__variant">' + item.variant_title + " pack</p>" : "") +
        '</div>' +
        '<button class="cart-line__remove" data-remove="' + item.key + '" aria-label="Remove">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>' +
        "</button></div>" +
        '<div class="cart-line__bottom">' +
          '<div class="qty-stepper">' +
            '<button data-change="' + item.key + '|-1" aria-label="Decrease"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14"/></svg></button>' +
            "<span>" + item.quantity + "</span>" +
            '<button data-change="' + item.key + '|1" aria-label="Increase"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14"/></svg></button>' +
          "</div>" +
          '<span class="cart-line__price">' + formatMoney(item.final_line_price) + "</span>" +
        "</div>" +
      "</div></li>"
    );
  }

  function refreshCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var countEls = document.querySelectorAll("[data-cart-count]");
      countEls.forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      var body = drawerRoot && drawerRoot.querySelector("[data-drawer-body]");
      var footer = drawerRoot && drawerRoot.querySelector("[data-drawer-footer]");
      if (!body || !footer) return;

      if (cart.item_count === 0) {
        body.innerHTML =
          '<div class="drawer-empty">' +
            '<span class="drawer-empty__icon"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></span>' +
            "<h3>Your cart is empty</h3><p>Add some premium dry fruits to get started.</p>" +
            '<button class="btn btn--primary" data-cart-close>Browse bestsellers</button>' +
          "</div>";
        footer.style.display = "none";
        return;
      }

      footer.style.display = "";
      body.innerHTML = '<ul style="list-style:none;margin:0;padding:0">' + cart.items.map(cartItemHTML).join("") + "</ul>";

      var threshold = (window.theme && window.theme.freeShippingThreshold) || 79900;
      var remaining = threshold - cart.total_price;
      var note = footer.querySelector("[data-ship-note]");
      if (note) {
        if (remaining > 0) {
          note.classList.remove("ship-note--unlocked");
          note.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M5 12a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4"/><path d="M12 12v6a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-7Z"/></svg> Add ' + formatMoney(remaining) + " more for free shipping";
        } else {
          note.classList.add("ship-note--unlocked");
          note.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg> You have unlocked free shipping';
        }
      }
      var subEl = footer.querySelector("[data-subtotal]");
      if (subEl) subEl.textContent = formatMoney(cart.total_price);
    }).catch(function () {});
  }

  drawerRoot && drawerRoot.addEventListener("click", function (e) {
    var chg = e.target.closest("[data-change]");
    if (chg) {
      var parts = chg.getAttribute("data-change").split("|");
      changeLine(parts[0], parseInt(parts[1], 10), chg);
      return;
    }
    var rem = e.target.closest("[data-remove]");
    if (rem) { setLine(rem.getAttribute("data-remove"), 0); return; }
    if (e.target === drawerRoot.querySelector(".drawer-backdrop")) closeCart();
  });

  function setLine(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCart(); });
  }
  function changeLine(key, delta, btn) {
    var line = btn && btn.closest(".cart-line");
    var qtyEl = line && line.querySelector(".qty-stepper span");
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    setLine(key, Math.max(0, current + delta));
  }

  /* ---------- add to cart ---------- */
  function addToCart(variantId, qty, button) {
    if (!variantId) return;
    if (button) { button.disabled = true; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed");
      toast("Added to cart");
      openCart();
      if (button) {
        button.classList.add("is-added");
        setTimeout(function () { button.classList.remove("is-added"); button.disabled = false; }, 1200);
      }
    }).catch(function () {
      toast("Could not add — try again");
      if (button) button.disabled = false;
    });
  }

  /* ---------- product cards with size pills ---------- */
  document.querySelectorAll("[data-product-card]").forEach(function (card) {
    var dataEl = card.querySelector("[data-variants-json]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var pills = card.querySelectorAll("[data-variant-id]");
    var priceEl = card.querySelector("[data-price]");
    var compareEl = card.querySelector("[data-compare]");
    var addBtn = card.querySelector("[data-add]");
    var selected = variants.find(function (v) { return v.available; }) || variants[0];

    function apply(v) {
      selected = v;
      pills.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-variant-id") === String(v.id));
      });
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = "";
        } else { compareEl.style.display = "none"; }
      }
      if (addBtn) addBtn.disabled = !v.available;
    }

    pills.forEach(function (p) {
      p.addEventListener("click", function () {
        var v = variants.find(function (x) { return String(x.id) === p.getAttribute("data-variant-id"); });
        if (v) apply(v);
      });
    });
    if (addBtn) {
      addBtn.addEventListener("click", function () { addToCart(selected.id, 1, addBtn); });
    }
    apply(selected);
  });

  /* ---------- product page ---------- */
  var pdp = document.querySelector("[data-pdp]");
  if (pdp) {
    var dataEl2 = pdp.querySelector("[data-variants-json]");
    var variants2 = [];
    try { variants2 = JSON.parse(dataEl2.textContent); } catch (e) {}
    var pills2 = pdp.querySelectorAll("[data-variant-id]");
    var priceEl2 = pdp.querySelector("[data-price]");
    var compareEl2 = pdp.querySelector("[data-compare]");
    var note2 = pdp.querySelector("[data-price-note]");
    var addBtn2 = pdp.querySelector("[data-add]");
    var qtyEl = pdp.querySelector("[data-qty]");
    var qty = 1;
    var selected2 = variants2.find(function (v) { return v.available; }) || variants2[0];

    function apply2(v) {
      selected2 = v;
      pills2.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-variant-id") === String(v.id));
      });
      if (priceEl2) priceEl2.textContent = formatMoney(v.price);
      if (compareEl2) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl2.textContent = formatMoney(v.compare_at_price);
          compareEl2.style.display = "";
        } else { compareEl2.style.display = "none"; }
      }
if (note2) {
  note2.textContent = v.title + " pack";
}      if (addBtn2) addBtn2.disabled = !v.available;
    }
    pills2.forEach(function (p) {
      p.addEventListener("click", function () {
        var v = variants2.find(function (x) { return String(x.id) === p.getAttribute("data-variant-id"); });
        if (v) apply2(v);
      });
    });
    pdp.querySelectorAll("[data-qty-change]").forEach(function (b) {
      b.addEventListener("click", function () {
        qty = Math.max(1, qty + parseInt(b.getAttribute("data-qty-change"), 10));
        if (qtyEl) qtyEl.textContent = qty;
      });
    });
    if (addBtn2) {
      addBtn2.addEventListener("click", function () { addToCart(selected2.id, qty, addBtn2); });
    }
    if (selected2) apply2(selected2);

    // gallery thumbs
    var mainImg = pdp.querySelector("[data-main-image] img");
    pdp.querySelectorAll("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        pdp.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
        if (mainImg) mainImg.src = t.getAttribute("data-thumb");
      });
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCart();
  });

  // initial cart count
  fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }).catch(function () {});
})();
